import React from "react";

// Minimal renderer for the AI summary markdown (**bold** + - bullets).
export default function SummaryView({ text }) {
  if (!text) return null;
  const lines = text.split("\n");
  const render = (s) =>
    s.split(/(\*\*[^*]+\*\*)/g).map((p, i) =>
      p.startsWith("**") && p.endsWith("**")
        ? <strong key={i} className="text-navy">{p.slice(2, -2)}</strong>
        : <span key={i}>{p}</span>
    );
  return (
    <div className="space-y-1 text-sm text-gray-700 leading-relaxed" data-testid="summary-view">
      {lines.map((ln, i) => {
        const t = ln.trim();
        if (!t) return <div key={i} className="h-1.5" />;
        if (t.startsWith("- ") || t.startsWith("* ")) {
          return (
            <div key={i} className="flex gap-2 pl-1">
              <span className="text-gold-dark mt-1.5 h-1 w-1 rounded-full bg-gold-dark flex-shrink-0" />
              <span>{render(t.slice(2))}</span>
            </div>
          );
        }
        return <p key={i}>{render(t)}</p>;
      })}
    </div>
  );
}
